// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"e166e321","362":"d677e126","410":"a979fda2","462":"99903d7c","487":"7dbceb54","761":"3d71336b","810":"494d1fa4"}[chunkId] + ".chunk.css";
};